<template>
  <svg>
    <linearGradient x2="0" y2="1" :id="`maskSource-${_uid}`">
      <stop
        v-for="(item, i) in stopColors"
        :key="i"
        :offset="item.offset"
        :stop-color="item.color"
      />
    </linearGradient>

    <mask maskUnits="userSpaceOnUse" :id="`maskImage-${_uid}`">
      <image width="100%" height="100%" v-bind="{ 'xlink:href': src }"></image>
    </mask>

    <rect x="0" y="0" width="100%" height="100%" :style="styles"></rect>
  </svg>
</template>

<script>
export default {
  name: "LuminanceMask",

  props: {
    src: String,
    stopColors: {
      type: Array,
      default: () => [{ offset: "50%", color: "currentColor" }]
    }
  },

  computed: {
    styles() {
      return {
        fill: `url(#maskSource-${this._uid})`,
        mask: `url(#maskImage-${this._uid})`
      };
    }
  }
};
</script>
